export enum FieldValidatorsName {
  MAX_LENGTH = 'max-length',
  MIN_LENGTH = 'min-length',
  REQUIRED = 'required',
  ARGENTINA_DNI = 'argentina_dni',
  ARGENTINA_CUIL = 'argentina_cuil'
}